import axiosInstance from '../../shared/api/axios-instance';

type CrateTaskPayload = {
  contactid: string;
  frage: string;
  dueDate: string;
  comment?: string;
};

type GetSupportBoxContactsPayload = {
  path: string;
};

export const getSupportBoxContacts = async (payload: GetSupportBoxContactsPayload) => {
  try {
    const url = 'Kontakt/GetSupportBoxContacts';
    return await axiosInstance({
      method: 'POST',
      url,
      data: payload
    });
  } catch (error) {
    console.log(error);
  }
};

export const createTask = async (payload: CrateTaskPayload) => {
  try {
    const url = 'support/CreateTask';
    const { contactid, frage, dueDate, comment } = payload;

    await axiosInstance({
      method: 'POST',
      url,
      data: {
        contactid,
        frage,
        dueDate,
        comment
      }
    });
  } catch (error) {
    console.log(error);
  }
};
